import sampleMp3 from '@/assets/music/sample.mp3'
import store from '@/store'

// 一个非常轻量的全局音乐控制器：
// - 首次 toggle 时创建 Audio
// - 再次 toggle 在 play/pause 间切换
// - 默认循环播放

let audio = null

export function toggleBgm() {
  if (!audio) {
    audio = new Audio(sampleMp3)
    audio.loop = true
    audio.preload = 'auto'
  }

  if (audio.paused) {
    return audio.play().then(() => {
      store.commit('SET_MUSIC_PLAYING', true)
    })
  }
  audio.pause()
  store.commit('SET_MUSIC_PLAYING', false)
  return Promise.resolve()
}

export function isBgmPlaying() {
  return !!audio && !audio.paused
}
